import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import { StyledDeliverSuccess } from './DeliverSuccess.style'

interface DeliverSuccessProps extends LibraryComponentType {
  onAction?: () => void
}

const DeliverSuccess: FC<DeliverSuccessProps> = ({ onAction, onClose }) => {
  const { t } = useTranslation()

  const onClick = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledDeliverSuccess>
      <div>
        <RiCheckboxCircleFill size={64} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.large} mt={theme.spacing.medium}>
        {`${t('trip.deliverSuccess.title')}`}
      </Text>
      <Text as="p" fontSize="medium" mb={theme.spacing.large}>
        {`${t('trip.deliverSuccess.desc')}`}
      </Text>
      <Button onClick={onClick}>{`${t('button.ok')}`}</Button>
    </StyledDeliverSuccess>
  )
}

DeliverSuccess.defaultProps = {
  onAction: () => null,
}

export default DeliverSuccess
